<div class="card">
    <div class="card-header">
        <b>Generar Reporte por Rango de Fecha</b>
    </div>
    <div class="card-body">
        <form [formGroup]="formCriterios">
            <div class="row">
                <div class="col-12">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Tipo</mat-label>
                        <mat-select formControlName="tipo">
                            <mat-option *ngFor="let tipo of tipoReportes" [value]="tipo.key">
                                {{ tipo.value }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Fecha Inicio</mat-label>
                        <input matInput [matDatepicker]="picker1" formControlName="fechaInicio">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Fecha Fin</mat-label>
                        <input matInput [matDatepicker]="picker2" formControlName="fechaFin">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <button mat-button class="primary" (click)="generarReporte()">Generar Reporte</button>
        </form>
    </div>
</div>

<div class="card mt-2" *ngIf="STEP == 2" id="step2">
    <div class="card-header">
        <b>Reporte Generado</b>
    </div>
    <div class="card-body">
        <blockquote class="blockquote mb-0">
            <div class="row">
                <div class="col-sm-6">
                    <p>
                        Registros: <strong>{{registros}}</strong>
                    </p>
                </div>
                <div class="col-sm-6">
                    <p>
                        Formato: <strong>xlsx</strong>
                    </p>
                </div>
            </div>
        </blockquote>
        <hr>
        <a [href]="url" mat-button class="primary">Guardar Reporte</a>
    </div>
</div>